import PropTypes from 'prop-types';
import V360Versions from './V360Versions';
import css from './V360Versions.scss';

V360Versions.displayName = 'V360Versions';

const classes = {
	root: css.v360Versions,
	thumb: css.v360VersionsThumb,
	thumbList: css.v360VersionsThumbList,
	thumbItem: css.v360VersionsThumbItem,
	thumbLink: css.v360VersionsThumbLink,
	thumbBox: css.v360VersionsThumbBox,
	thumbFigure: css.v360VersionsThumbFigure,
	thumbImage: css.v360VersionsThumbImage,
	thumbCaption: css.v360VersionsThumbCaption,
	isActive: css.isActive,
};

V360Versions.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	list: PropTypes.array,
	currentType: PropTypes.number,
	mobile: PropTypes.bool,
	onChange: PropTypes.func,
};

V360Versions.defaultProps = {
	className: '',
	classes,
	list: [],
	currentType: undefined,
	mobile: true,
	onChange: Function.prototype,
};

export { V360Versions };
export default V360Versions;
